export const TOGGLE_REPORT_BUG_DIALOG = 'TOGGLE_REPORT_BUG_DIALOG'
